import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { FileManagerViewModule } from '../modules/file-manager/file-manager-view/file-manager-view.module';
import { FileManagerModule } from '../modules/file-manager/file-manager.module';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularSplitModule } from 'angular-split';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DxDataGridModule, DxPopoverModule, DxAccordionModule } from 'devextreme-angular';
import { TDOPipesModule } from '../modules/tdo-shared/tdo-pipes.module';
import { LandingRoutingModule } from './landing-routing.module';
import { NoteCompactV2Module } from '../modules/notes/note-compact-v2/note-compact-v2.module';
import { LpProcedurePipe } from './pipes/lp-procedure.pipe';
import { NoteCompactModule } from '../modules/notes/note-compact/note-compact.module';
import { CaseFormsModule } from '../modules/case-forms/case-forms.module';
import { CaseCreateWizardModule } from '../modules/case-create-wizard/case-create-wizard.module';
import { ImagingModule } from '../modules/imaging/imaging.module';
import { eRxModule } from '../modules/erx/erx.module';
import { PatientModule } from '../modules/patient/patient.module';
import { GeneralContextModule } from '../modules/tdo-shared/general-context/general-context.module';
import { NoteInlineModule } from '../modules/notes/note-inline/note-inline.module';

import { AuthGuard } from '../modules/auth/helpers/authguard';
import {MatExpansionModule} from '@angular/material/expansion';
import {TdoControlsModule} from '../tdo-controls/tdo-controls.module';
import {MainInterfaceModule} from '../main-interface/main-interface.module';
import { TestingComponent } from './testing/testing.component';
import {TreatmentPlanningModule} from '../modules/treatment-planning/treatment-planning.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ReferralManagerComponent} from '../modules/referral-manager/referral-manager.component';
import {MaterialModule} from '../modules/material.module';
import {ValidValueSelectModule} from "../tdo-controls/validvalueselect/validvalueselect-module";
//import {FilterTreatmentsPipe} from '../modules/referral-manager/pipes/filter-treatments.pipe';
//import {FilterOthTreatmentsPipe} from '../modules/referral-manager/pipes/filter-oth-treatments.pipe';

@NgModule({
  declarations: [
    LandingComponent,
    LpProcedurePipe,
    TestingComponent,
    ReferralManagerComponent,
  ],
    imports: [
        FormsModule, HttpClientModule,
        GeneralContextModule,
        TDOPipesModule, NoteCompactV2Module,
        FileManagerModule, FileManagerViewModule,
        LandingRoutingModule, NoteCompactModule,
        CaseFormsModule, CaseCreateWizardModule,
        ImagingModule, eRxModule, PatientModule,
        NoteInlineModule,
        MatButtonModule, MatIconModule, MatDividerModule,
        MatCheckboxModule, MatTabsModule, MatTooltipModule,
        DxDataGridModule, DxPopoverModule, DxAccordionModule,
        AngularSplitModule, MatExpansionModule, TdoControlsModule, MainInterfaceModule, TreatmentPlanningModule,
        MatProgressBarModule, MaterialModule,
        CommonModule, ValidValueSelectModule
    ],
  providers: [
    AuthGuard
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class LandingModule { }
